<template>
  <div class="wrapper">
    <c-el-page-header :detail="headerTitle" />
    <div  v-if="historyData.length > 0">
      <div
        class="list-wrap"
        v-for="(item, index) in historyData"
        :key="index"
      >
        <div class="card-content">
          <div class="title">
            <span>{{ item.tcStChkTime }}</span>
            <span>{{ item.tcStItemName }}</span>
          </div>
          <div class="middle">
            <span v-if="handlePermission('电子胶片')">胶片数：{{ item.filmImageSum }}</span>
            <span>序列数：{{ item.filmSeriesSum }}</span>
            <span>检查类型：{{ item.tcStType }}</span>
          </div>
          <div :class="[item.showTotal ? 'total-introduce' : 'detailed-introduce']">
            <div class="yingxiang-box">
              <span>影像所见：</span><span v-if="item.reportStat === 'RA'">{{ item.tcRpFindings }}</span>
            </div>
            <div class="zhenduan-box">
              <span>诊断结论：</span>
              <span v-if="item.reportStat === 'RA'">{{ item.tcRpInspectCon }}
                
              </span>
            </div>
            <svg-icon
              v-if="!item.exchangeButton"
              icon-class="down"
              class-name="down"
              @click="handleShowTotals(index)"
            />
            <svg-icon
              v-if="item.exchangeButton"
              icon-class="up"
              class-name="up"
              @click="handleShowTotals(index)"
            />
          </div>
          <div class="icon-wrap">
            <div class="icon_content" @click="ImageTextLink(item)" v-if="handlePermission('图文报告')">
              <svg-icon icon-class="tuwen-s" class-name="icon" />
              <span>图文报告</span>
            </div>
            <div class="icon_content" @click="jiaopiansLink(item)" v-if="handlePermission('电子胶片')">
              <svg-icon icon-class="jiaopian-s" class-name="icon" />
              <span>电子胶片</span>
            </div>
            <div class="icon_content" @click="yingxiangsLink(item)" v-if="handlePermission('影像浏览')">
              <svg-icon icon-class="yingxiang-s" class-name="icon" />
              <span>影像浏览</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box_s" v-else>
      <c-el-empty />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getNetworkType } from '../utils/index'
import { ElMessageBox } from 'element-plus'
export default {
  components: {},
  props: {},
  data () {
    return {
      headerTitle: '历史检查'
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['homeInfo', 'historyData','buttonCfg'])
  },
  methods: {
    handleShowTotals (i) {
      this.historyData[i].showTotal = !this.historyData[i].showTotal
      this.historyData[i].exchangeButton = !this.historyData[i].exchangeButton
    },
    jiaopiansLink (item) {
      var params = {
        patientid: item.tcPtDispNo,
        hospcode: item.tcHospCode,
        studyid: item.tcStGrpNo,
        hospdomain: item.tcHospDomain,
        checkTime: item.tcStChkTime
      }
      this.$router.push({
        path: '/electronicFilm',
        query: params
      })
    },
    yingxiangsLink (item) {
      var params = {
        patientid: item.tcPtDispNo,
        hospcode: item.tcHospCode,
        studyid: item.tcStGrpNo,
        hospdomain: item.tcHospDomain,
        checkTime: item.tcStChkTime,
        tcStType: item.tcStType,
        enterFlag: 'enterFlag'
      }
      if (['wifi'].indexOf(getNetworkType()) === -1) {
        ElMessageBox.confirm(
          '下载影像需要流量较大，是否继续下载？',
          '温馨提示',
          {
            confirmButtonText: '继续下载',
            cancelButtonText: '取消',
            type:'info',
            center: true,
            showClose:false
          }
        )
          .then(() => {
            this.$router.push({
              path: '/imageBrowsing',
              query: params
            })
          })
          .catch(() => {

          })
      } else {
        this.$router.push({
          path: '/imageBrowsing',
          query: params
        })
      }
    },
    ImageTextLink (item) {
      var params = {
        tcStType: item.tcStType,
        checkTime: item.tcStChkTime,
        patientid: item.tcPtDispNo,
        hospcode: item.tcHospCode,
        studyid: item.tcStGrpNo,
        hospdomain: item.tcHospDomain
      }
      this.$router.push({
        path: '/imageAndText',
        query: params
      })
    },
    handlePermission(name){
      let ok = false;
      if(this.buttonCfg){
        if(this.buttonCfg.length > 0){
          for(let i =0;i < this.buttonCfg.length; i++){
            if(this.buttonCfg[i].name == name){
              ok = true;
              break
            }
          }
        }else{
          ok = true
        }
      }else{
        ok = true
      }
      return ok
    },
  },

  async created () {
        // 获取 buttonCfg 信息
    await this.$store.dispatch("getDicByFieldName",{
      fieldName:'buttonCfg'
    })
    const patientid = this.$route.query.patientid
    // 请求数据
    this.$store
      .dispatch('getHistoryCheckData', patientid)
      .then(() => {
        this.historyData.forEach((element) => {
          element.showTotal = false
          element.exchangeButton = true
        })
        if (this.historyData && this.historyData.length > 0 && this.historyData[0].tcPtName) {
          this.headerTitle = '历史检查 - ' + this.historyData[0].tcPtName
        } else {
          this.headerTitle = '历史检查'
        }
      })
      .catch(() => {})
  },
  mounted () {}
}
</script>
<style lang="scss" scope>
@import "../style/theme.scss";
@import "../style/historyCheck.scss";
</style>
